//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
      },
      showPicking: false,
      orderStatus: "",
      orderNumber: "",
      showOrderPacking: false,
      savePackingInProgress : false,
      customers: [],
      orderLines: [],
      selectedLine: {},
      order: [],
      stock: [],
      packings: [],
      pickedProductsReadyToPackaging: [],
      transactions: [],
      warehouseId: -1,
      restQuantity: 0,
      LocationId: -1,
      lineQuantity: 0,
      picked: 0,
      volume: 0,
      qtyParcel: 0,
      weight: 0,
      packingSlips: false,
      consignor: false,

      sendMail: true,
      disablePick: true,
      Warehouses: [],
      FilterWarehouses: [],
      Locations: [],
      FilterLocations: [],
      tab: "details",
      tabCustomer: "customerTab",
      id: 0,

      rowCount: 10,
      existingOrder: false,
      dense: true,
      orderDate: date.formatDate(Date.now(), "DD-MM-YYYY"),
      deliveryDate: date.formatDate(Date.now(), "DD-MM-YYYY"),

      columns: [
        {
          name: "productNumber",
          align: "left",
          label: this.$t("order.productNumber"),
          field: "productNumber",
          style: "width: 200px",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: this.$t("order.productName"),
          field: "productName",
          sortable: true,
        },
        {
          name: "itemText",
          align: "left",
          label: this.$t("order.itemText"),
          field: "itemText",
          sortable: true,
        },

        {
          name: "quantity",
          align: "right",
          label: this.$t("order.quantity"),
          field: "numberOfItems",
          style: "width: 100px",
          sortable: true,
        },
        {
          name: "picked",
          align: "right",
          label: this.$t("order.qtypicked"),
          field: "picked",
          style: "width: 100px",
          sortable: true,
        },
        {
          name: "numberOfItemsAvailableInStock",
          align: "right",
          label: this.$t("products.qty"),
          field: "numberOfItemsAvailableInStock",
          style: "width: 100px",
          sortable: true,
        },
      ],
      stocks: [
        {
          name: "locationName",
          align: "left",
          label: this.$t("order.locationName"),
          field: "locationName",
          sortable: true,
        },
        {
          name: "picked",
          align: "left",
          label: this.$t("order.picked"),
          field: "picked",
          sortable: true,
        },
      ],
      pickedProductsReadyToPackagingColumn: [
        {
          name: "productName",
          align: "left",
          label: this.$t("order.productName"),
          field: "productName",
          sortable: true,
        },
        {
          name: "locationName",
          align: "left",
          label: this.$t("order.locationName"),
          field: "locationName",
          sortable: true,
        },
        {
          name: "picked",
          align: "left",
          label: this.$t("order.picked"),
          field: "picked",
          sortable: true,
        },
      ],
      packageColumns: [
        {
          name: "id",
          align: "left",
          label: "Id",
          field: "id",
          sortable: true,
        },
        {
          name: "parcels",
          align: "left",
          label: "Kolli",
          field: "parcels",
          sortable: true,
        },
        {
          name: "volume",
          align: "left",
          label: "Volume",
          field: "volume",
          sortable: true,
        },
        {
          name: "weight",
          align: "left",
          label: "Vekt",
          field: "weight",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("main", ["warehouses", "locations"]),
  },

  watch: {
    warehouseId(newValue, oldValue) {
      if (newValue != oldValue) {
        this.newLocationId = -1;
      }
    },
    picked(newValue, oldValue) {
      if (newValue != oldValue) {
        if (this.picked > this.restQuantity) {
          this.disablePick = true;
        } else if (this.picked < 0) {
          this.disablePick = true;
        } else if (this.picked > this.LocationId.quantity) {
          this.disablePick = true;
        } else if (this.restQuantity == 0) {
          this.disablePick = true;
        } else if (this.picked == 0) {
          this.disablePick = true;
        } else if (!this.picked) {
          this.disablePick = true;
        } else {
          this.disablePick = false;
        }
      }
    },
  },
  methods: {
    async savePicking() {
      var postStock = {};
      postStock.customerOrderItemId = this.selectedLine.id;
      postStock.locationId = this.LocationId;
      postStock.picked = parseFloat(this.picked);

      try {
        var createdDto = await this.postCustomerOrderItemTransaction(postStock);
        if (createdDto) {
          await this.refresh();

          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk"),
          });
        } else {
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave"),
          });
        }
      } catch (err) {
        console.log(err.message);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },
    async deleteval(row) {
      var res = await this.deleteCustomerOrderItemTransaction(row.id);

      if (res == "true") {
        var index = this.transactions.indexOf(row);
        this.transactions.splice(index, 1);
        await this.refresh();
      } else {
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },

    async packOrder() {
      this.pickedProductsReadyToPackaging = await this.getCustomerOrderItemTransactions(
        this.$route.params.id
      );
      this.showOrderPacking = true;
    },

    async packingSlipPdf(packageId) {
      var res = await this.getPackingSlipReport(packageId);

      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      // link.setAttribute("download", "PackingSlip.pdf");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      this.packingSlips = false;
    },
    async openPackingSlips() {
      this.packingSlips = true;
      this.packings = await this.getCustomerOrderPackage(this.id);
    },

    async savePacking() {
      this.savePackingInProgress = true;
      var postPacking = {};
      postPacking.customerOrderId = parseInt(this.$route.params.id);
      postPacking.parcels = parseFloat(this.qtyParcel);
      postPacking.volume = parseFloat(this.volume);
      postPacking.weight = parseFloat(this.weight);
      postPacking.sendToConsignor = this.consignor;
      try {
        var createdDto = await this.postCustomerOrderPackage(postPacking);
        if (createdDto && createdDto.id > 0) {
          await this.packingSlipPdf(createdDto.id);

          await this.refresh();
          this.showOrderPacking = false;
          this.volume = 0;
          this.qtyParcel = 0;
          this.weight = 0;
          this.consignor = false;
          this.packingslip = true;
          this.sendMail = true;
          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk"),
          });
        } else {
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave"),
          });
        }
        this.showOrderPacking = false;
        this.savePackingInProgress = false;
      } catch (err) {
        console.log(err.message);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
      this.savePackingInProgress = false;
    },
    async refresh() {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.id = this.$route.params.id;
      if (this.id > 0) {
        await this.fetchOrder(this.id);
        this.existingOrder = true;
        this.updateForm();
      }

      setTimeout(() => {
        notif();
      }, 500);
    },
    onRowClick(row) {
      this.resetForm();
      this.selectedLine = row;
      this.numberOfItems = row.numberOfItems;
      this.restQuantity = this.numberOfItems - row.picked;
      this.picked = row.picked;
      this.lineQuantity = row.quantity;
      this.picked = row.quantity;
      this.stock = row.stock;
      this.transactions = row.transactions;
      console.log(this.stock);
      this.disablePick = true;
      this.showPicking = true;
    },

    getWarehouseFilter(val, update) {
      console.log("getWarehouseFilter", this.Warehouses);
      if (!this.Warehouses) {
        update();
        return;
      }
      update(() => {
        this.Warehouses = this.FilterWarehouses.filter(
          (w) =>
            !w.isDeleted &&
            w.warehouseName.toLowerCase().indexOf(val.toLowerCase()) > -1
        );

        console.log("getWarehouseFilter update", this.Warehouses);
      });
    },

    getLocationsFilter(val, update) {
      console.log("getLocationsFilter", this.Locations);
      if (!this.Locations) {
        update();
        return;
      }
      update(() => {
        this.Locations = this.stock.filter(
          (l) => this.warehouseId < 1 || l.warehouseId == this.warehouseId
        );

        console.log("getLocationsFilter update", this.Locations);
      });
    },
    resetForm() {
      this.picked = 0;
      this.warehouseId = -1;
      this.LocationId = -1;
    },

    updateForm() {
      this.picked = "";
      this.warehouseId = -1;
      this.LocationId = -1;
      var selectedLine = this.order.orderItems.find(
        (x) => x.id == this.selectedLine.id
      );
      this.transactions = selectedLine.transactions;
      this.restQuantity = this.numberOfItems - selectedLine.picked;
    },

    async fetchOrder(id) {
      const data = await this.getSalesOrder(id);

      this.order = data;
      this.orderNumber = this.order.orderNumber.toString();
      this.orderStatus = this.$t(
        "order.status-" + this.order.customerOrderStatusId
      );

      this.mapOrder(data);
    },
    mapOrder(data) {
      (this.orderDate = date.formatDate(data.orderDate, "DD-MM-YYYY")),
        (this.deliveryDate = date.formatDate(data.deliveryDate, "DD-MM-YYYY")),
        (this.orderLines = data.orderItems);
    },
    ...mapActions("main", [
      "getSalesOrder",
      "getCustomer",
      "postCustomerOrderItemTransaction",
      "deleteCustomerOrderItemTransaction",
      "getCustomerOrderItemTransactions",
      "postCustomerOrderPackage",
      "getCustomerOrderPackage",
      "getPackingSlipReport",
    ]),
  },
  created() {
    // GET request using fetch with error handling
    this.Warehouses = this.warehouses;
    this.FilterWarehouses = this.warehouses;
    this.Locations = this.locations;
    this.FilterLocations = this.locations;
    this.id = this.$route.params.id;
    if (this.id > 0) {
      this.fetchOrder(this.id);
      this.existingOrder = true;
    }
  },
};
